<template>
  <div class="grading-report-ai-feedback">
    <h3>AI FEEDBACK</h3>
    <div class="scroll-content md-scrollbar md-theme-default">
      <p
        v-for="(line, index) in reportLines"
        :key="'line' + index"
        class="feedback-item"
      >
        {{ line }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'grading-report-ai-feedback',
  props: {
    report: {
      type: Object,
      required: true
    },
  },
  computed: {
    reportLines() {
      if (this.report && this.report.aiReport) {
        return this.report.aiReport.split('\n');
      } else {
      // If there is no report, return a placeholder item.  This is necessary because v-if
      // is not working when inside the vue slick component
        return ['AI feedback not available'];
      }
    }
  },
}
</script>

<style scoped>
.grading-report-ai-feedback {
  min-height: 0;
  display: flex !important;
  flex-direction: column;
  flex-grow: 1;
}
.scroll-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.feedback-item {
  font-size: 14px;
}
</style>